/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationCrossPlayHandlersQuestProgressDto } from './FxIdApplicationCrossPlayHandlersQuestProgressDto';
import {
    instanceOfFxIdApplicationCrossPlayHandlersQuestProgressDto,
    FxIdApplicationCrossPlayHandlersQuestProgressDtoFromJSON,
    FxIdApplicationCrossPlayHandlersQuestProgressDtoFromJSONTyped,
    FxIdApplicationCrossPlayHandlersQuestProgressDtoToJSON,
} from './FxIdApplicationCrossPlayHandlersQuestProgressDto';

/**
 * @type FxIdApplicationCrossPlayHandlersUserQuestDtoProgress
 * 
 * @export
 */
export type FxIdApplicationCrossPlayHandlersUserQuestDtoProgress = FxIdApplicationCrossPlayHandlersQuestProgressDto;

export function FxIdApplicationCrossPlayHandlersUserQuestDtoProgressFromJSON(json: any): FxIdApplicationCrossPlayHandlersUserQuestDtoProgress {
    return FxIdApplicationCrossPlayHandlersUserQuestDtoProgressFromJSONTyped(json, false);
}

export function FxIdApplicationCrossPlayHandlersUserQuestDtoProgressFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationCrossPlayHandlersUserQuestDtoProgress {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationCrossPlayHandlersQuestProgressDto(json)) {
        return FxIdApplicationCrossPlayHandlersQuestProgressDtoFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationCrossPlayHandlersUserQuestDtoProgressToJSON(json: any): any {
    return FxIdApplicationCrossPlayHandlersUserQuestDtoProgressToJSONTyped(json, false);
}

export function FxIdApplicationCrossPlayHandlersUserQuestDtoProgressToJSONTyped(value?: FxIdApplicationCrossPlayHandlersUserQuestDtoProgress | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationCrossPlayHandlersQuestProgressDto(value)) {
        return FxIdApplicationCrossPlayHandlersQuestProgressDtoToJSON(value as FxIdApplicationCrossPlayHandlersQuestProgressDto);
    }

    return {};
}

